

















































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
// import { Counterpart, CounterpartTypes } from '../../models/All';

@Component
export default class CounterpartView extends Vue {
  public items: Common.Counterpart[] = new Array(0);
  public params: Common.CounterpartQuery = new Common.CounterpartQuery();
  public tabVisibles: Array<boolean> = [true, true, true, true, true, true, true, true, true, true];
  public importQuery = new Common.CounterpartImportQuery('取引先');
  public exportQuery = new Common.CounterpartExportQuery('取引先', this.params);
  public customerFlag = Common.CounterpartTypes.Customer;
  public supplierFlag = Common.CounterpartTypes.Supplier;
  public receiverFlag = Common.CounterpartTypes.Receiver;
  public warehouseFlag = Common.CounterpartTypes.Warehouse;
  public customerOrSupplierFlag = Common.CounterpartTypes.Customer | Common.CounterpartTypes.Supplier;
  public customerOrReceiverFlag = Common.CounterpartTypes.Customer | Common.CounterpartTypes.Receiver;
  public supplierOrWarehouseFlag = Common.CounterpartTypes.Supplier | Common.CounterpartTypes.Warehouse;
  public customerOrSupplierOrWarehouseFlag = Common.CounterpartTypes.Customer | Common.CounterpartTypes.Supplier | Common.CounterpartTypes.Warehouse;
  public tenantSettings: Common.TenantSettings = new Common.TenantSettings();
  public hasLicenseCurrency: boolean = false;
  public hasLicenseImport: boolean = false;
  public hasLicenseExport: boolean = false;
  @Prop() public auditNo:string;
  @Prop({default:null}) public popup: Components.PopupEditor;  
  @Prop({default:0}) public popupCounterpartTypeDisabled: number;  

  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'code', text: 'コード' },
    { value: 'name', text: '名称' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
  ];
  
  public created() {
    //テナント設定をロードする
    this.tenantSettings = this.$api.tenantSettings;
    
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    this.hasLicenseImport = this.$api.hasLicense(Common.licenseFlags.import);
    this.hasLicenseExport = this.$api.hasLicense(Common.licenseFlags.export);
    this.importQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.importQuery.hasLicenseImport = this.hasLicenseImport;
    this.importQuery.hasLicenseExport = this.hasLicenseExport;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.exportQuery.hasLicenseImport = this.hasLicenseImport;
    this.exportQuery.hasLicenseExport = this.hasLicenseExport;

    // 検索条件を設定する
    if(this.auditNo) {
      this.params.auditNo = this.auditNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    this.$api.formatter.ensureListLoaded('workflow_masterBase','taxCode');    

  }

  public async onCreate(obj: Common.Counterpart) {
    const workflows = this.$api.formatter.getOptions('workflow_masterBase');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    obj.currencyCode = this.tenantSettings.currencyCode;
    //税区分の初期値（課税売上）
    if(this.$api.formatter.getOptions('taxCodeObj').find(obj=> obj.value.name == '課税売上' && obj.value.state == Common.MasterBaseStatus.Posted))
      obj.taxCode = this.$api.formatter.getOptions('taxCodeObj').filter(obj=> obj.value.name == '課税売上' && obj.value.state == Common.MasterBaseStatus.Posted)[0].value.code;
    obj.invoiceType = Common.InvoiceTypes.ConsolidateInvoice;
    obj.closingDate1 = Common.DateTypes.LastDay;
    obj.dueDate1 = Common.DateTypes.LastDay;
    obj.paymentMonth1 = Common.MonthTypes.Month1Later;
    if(this.params != null && this.params.counterpartType != null && this.params.counterpartType != Common.CounterpartTypes.None){
      obj.counterpartType = this.params.counterpartType;
    }
    else if ((this.popupCounterpartTypeDisabled & Common.CounterpartTypes.Customer) == 0) obj.counterpartType = Common.CounterpartTypes.Customer;
    else if ((this.popupCounterpartTypeDisabled & Common.CounterpartTypes.Supplier) == 0)  obj.counterpartType = Common.CounterpartTypes.Supplier;
    else if ((this.popupCounterpartTypeDisabled & Common.CounterpartTypes.Receiver) == 0)  obj.counterpartType = Common.CounterpartTypes.Receiver;
    else if ((this.popupCounterpartTypeDisabled & Common.CounterpartTypes.Warehouse) == 0)  obj.counterpartType = Common.CounterpartTypes.Warehouse;    

    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  public workflowRequired(item: Common.Counterpart):boolean {
    if(item.state != Common.MasterBaseStatus.NotPosted) return false;
    var workflows = this.$api.formatter.getOptions('workflow_masterBase');
    return workflows.length > 0;
  }

  public onSelected(index: number, selected: Common.Counterpart) {
    this.onCounterpartTypeChanged(selected);
  }

  public onCounterpartTypeChanged(item: Common.Counterpart) {
    this.$set(this.tabVisibles, 1, this.isCustomer(item)); // 請求設定タブ
    this.$set(this.tabVisibles, 2, this.isSupplierOrWarehouse(item)); // 支払設定タブ    
    this.$set(this.tabVisibles, 3, this.isSupplierOrWarehouse(item)); // 振込連携設定（旧：全銀設定）タブ
    // this.$set(this.tabVisibles, 3, this.isCustomerOrSupplierOrWarehouse(item)); // その他設定タブ=>常に表示
    this.$set(this.tabVisibles, 5, (this.isCustomerOrSupplier(item) || this.isReceiver(item)) && (this.hasLicenseImport || this.hasLicenseExport)); // 貿易書類設定タブ
    this.$set(this.tabVisibles, 6,this.isCustomer(item)); // 帳票設定タブ
    this.$set(this.tabVisibles, 7, this.isCustomerOrSupplier(item) && this.$api.useStockFunction); // 予備項目タブ
    // this.$set(this.tabVisibles, 6, this.isCustomerOrSupplier(item)); // 集計項目タブ
    if(item.counterpartType != this.receiverFlag) item.customer = null;

    //画面項目がない状態で入力エラーの場合、エラーメッセージが表示できずシステムエラーとなるため、不要項目をクリアする
    //得意先以外
    if(item.counterpartType != Common.CounterpartTypes.Customer)
    {
      //請求設定タブ項目をクリア
      item.invoiceType = Common.InvoiceTypes.None;
      item.customerBankAccountCode = null;
      item.payer = null;
      item.payerId = null;
      //その他設定タブ項目をクリア
      item.salesPerson = null;
      item.salesPricingRate = 100;
    }

    if(item.counterpartType != Common.CounterpartTypes.Supplier)
    {
      // 仕入先以外の場合無効な項目を設定
      item.transportation = 0;
      item.shipVia = '';
      item.insurance = '';
      item.shipTo = '';
      item.invoiceNo = '';
    }

    //得意先・仕入先以外
    if(item.counterpartType != Common.CounterpartTypes.Customer && item.counterpartType != Common.CounterpartTypes.Supplier)
    {
      //その他設定タブ項目をクリア
      item.priceCategory = null;
      item.description = '';
      item.category1 = null;
      item.category2 = null;
      item.category3 = null;
      item.category4 = null;
      item.category5 = null;
      item.category6 = null;
      item.remark = '';
      //予備項目タブ項目をクリア
      item.reserveText1 = '';
      item.reserveText2 = '';
      item.reserveText3 = '';
      item.reserveText4 = '';
      item.reserveText5 = '';
      item.reserveText6 = '';
      item.reserveMemo1 = '';
      item.reserveMemo2 = '';
      item.reserveMemo3 = '';
      item.reserveList1 = null;
      item.reserveList2 = null;
      item.reserveList3 = null;
      //貿易設定タブ項目をクリア
      item.commodityName = 0;
      item.deliveryTerm = '';
      item.deliveryLocation = '';
    }

    //仕入先・倉庫以外
    if(item.counterpartType != Common.CounterpartTypes.Supplier && item.counterpartType != Common.CounterpartTypes.Warehouse)
    {
      //支払設定タブ項目をクリア
      item.bankName = '';
      item.bankBranchName = '';
      // item.accountType = '';
      item.accountCategory = Common.BankAccountCategoryTypes.Default;
      item.accountCode = '';
      // item.accountName = '';
      item.payee = null;
      item.payeeId = null;
    }

    //得意先・仕入先・倉庫以外
    if(item.counterpartType != Common.CounterpartTypes.Customer && item.counterpartType != Common.CounterpartTypes.Supplier && item.counterpartType != Common.CounterpartTypes.Warehouse)
    {
      //請求設定タブ・支払設定タブ項目をクリア
      item.paymentDateType = Common.PaymentDateTypes.Monthly;
      item.paymentSite = 0;
      item.closingDate1 = Common.DateTypes.None;
      item.dueDate1 = Common.DateTypes.None;
      item.paymentMonth1 = Common.MonthTypes.None;
      item.closingDate2 = Common.DateTypes.None;
      item.dueDate2 = Common.DateTypes.None;
      item.paymentMonth2 = Common.MonthTypes.None;
      item.paymentTerm = '';
      //その他設定タブ項目をクリア
      item.taxType = Common.TaxTypes.Without;
      item.taxCode = null;
      item.subAccountCode = '';
      item.accountName = '';
      item.currencyCode = null;
    }

    //得意先・納入先以外
    if(item.counterpartType != Common.CounterpartTypes.Customer && item.counterpartType != Common.CounterpartTypes.Receiver)
    {
        if(item.paymentDateType==Common.PaymentDateTypes.None) item.paymentDateType = Common.PaymentDateTypes.Monthly;
        //貿易設定タブ項目をクリア
        item.receiptPlace = '';
        item.loadingPort = '';
        item.dischargePort = '';
        item.deliveryPlace = '';
        item.countryOfDestination = '';
        item.payFreight = '';
        item.consignee = '';
        item.deliveredTo = '';
    }
  }


  public isCustomer(item: Common.Counterpart){
    return item.counterpartType == this.customerFlag;
  }

  public isSupplier(item: Common.Counterpart){
    return item.counterpartType == this.supplierFlag;
  }

  public isReceiver(item: Common.Counterpart){
    return item.counterpartType == this.receiverFlag;
  }

  public isWarehouse(item: Common.Counterpart){
    return item.counterpartType == this.warehouseFlag;
  }

  public isCustomerOrSupplier(item: Common.Counterpart){
    return (item.counterpartType & this.customerOrSupplierFlag) > 0;
  }

  public isCustomerOrReceiver(item: Common.Counterpart){
    return (item.counterpartType & this.customerOrReceiverFlag) > 0;
  }

  public isSupplierOrWarehouse(item: Common.Counterpart){
    return (item.counterpartType & this.supplierOrWarehouseFlag) > 0;
  }

  public isCustomerOrSupplierOrWarehouse(item: Common.Counterpart){
    return (item.counterpartType & this.customerOrSupplierOrWarehouseFlag) > 0;
  }

  public isNotPosted(item: Common.Counterpart){
    return item.state == Common.MasterBaseStatus.NotPosted;
  }

  public paymentDateTypeRequired(item: Common.Counterpart): boolean{
    if(this.isCustomerOrSupplierOrWarehouse(item) == false) return false;
    if(this.isCustomer(item) && item.invoiceType != Common.InvoiceTypes.SeparateInvoice){
      item.paymentDateType = Common.PaymentDateTypes.Monthly;
      return false;
    }
    return true;
  }

  public paymentSiteRequired(item: Common.Counterpart): boolean{
    if(this.isCustomerOrSupplierOrWarehouse(item) == false) return false;
    return item.paymentDateType == Common.PaymentDateTypes.Daily;
  }

  public closingDateRequired(item: Common.Counterpart): boolean{
    if(this.isCustomerOrSupplierOrWarehouse(item) == false) return false;
    return item.paymentDateType == Common.PaymentDateTypes.Monthly;
  }

  public async atcSalesOrderReportQuery():Promise<Common.BindItem[]> {
    return this.atcReportQuery("menu_sales_order");
  }
  public async atcSalesDeliveryReportQuery():Promise<Common.BindItem[]> {
    return this.atcReportQuery("menu_sales_delivery");
  }
  public async atcAloneInvoiceReportQuery():Promise<Common.BindItem[]> {
    return this.atcReportQuery("menu_invoice");
  }
  public async atcReportQuery(viewName:string):Promise<Common.BindItem[]> {
      var bindItems = new Array();
      var query = new Common.ReportTemplateViewQuery();
      query.viewName=viewName;
      await this.$api.execute(query).then(res => {
          var result = res as Common.LoadResult;
          result.result.forEach(obj =>{
            bindItems.push(new Common.BindItem(obj.id,obj.name));
          });
        });
      return Promise.resolve(bindItems);
  }
  public showDownloadImportFile:boolean = false;
  public dlCounterpartType:Common.CounterpartTypes = Common.CounterpartTypes.None;
  public showDownloadImportFileDialog(){
    this.dlCounterpartType = Common.CounterpartTypes.Customer;
    this.showDownloadImportFile = true;
  }
  public onImportFileDownload(){
    let url : string = '';
    switch(this.dlCounterpartType){
      case Common.CounterpartTypes.Customer:
        url = 'https://s-flow.net/downloads/%E3%82%B5%E3%83%9D%E3%83%BC%E3%83%88%E3%82%B5%E3%82%A4%E3%83%88%E8%B3%87%E6%96%99/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E5%85%A5%E5%87%BA%E5%8A%9B/%E5%BE%97%E6%84%8F%E5%85%88(%E5%8F%96%E5%BC%95%E5%85%88%E3%83%9E%E3%82%B9%E3%82%BF)%E3%82%A4%E3%83%B3%E3%83%9D%E3%83%BC%E3%83%88%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB.xlsx';
        break;
      case Common.CounterpartTypes.Supplier:
        url = 'https://s-flow.net/downloads/%E3%82%B5%E3%83%9D%E3%83%BC%E3%83%88%E3%82%B5%E3%82%A4%E3%83%88%E8%B3%87%E6%96%99/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E5%85%A5%E5%87%BA%E5%8A%9B/%E4%BB%95%E5%85%A5%E5%85%88(%E5%8F%96%E5%BC%95%E5%85%88%E3%83%9E%E3%82%B9%E3%82%BF)%E3%82%A4%E3%83%B3%E3%83%9D%E3%83%BC%E3%83%88%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB.xlsx';
        break;
      case Common.CounterpartTypes.Receiver:
        url = 'https://s-flow.net/downloads/%E3%82%B5%E3%83%9D%E3%83%BC%E3%83%88%E3%82%B5%E3%82%A4%E3%83%88%E8%B3%87%E6%96%99/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E5%85%A5%E5%87%BA%E5%8A%9B/%E7%B4%8D%E5%85%A5%E5%85%88(%E5%8F%96%E5%BC%95%E5%85%88%E3%83%9E%E3%82%B9%E3%82%BF)%E3%82%A4%E3%83%B3%E3%83%9D%E3%83%BC%E3%83%88%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB.xlsx';
        break;
      case Common.CounterpartTypes.Warehouse:
        url = 'https://s-flow.net/downloads/%E3%82%B5%E3%83%9D%E3%83%BC%E3%83%88%E3%82%B5%E3%82%A4%E3%83%88%E8%B3%87%E6%96%99/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E5%85%A5%E5%87%BA%E5%8A%9B/%E5%80%89%E5%BA%AB(%E5%8F%96%E5%BC%95%E5%85%88%E3%83%9E%E3%82%B9%E3%82%BF)%E3%82%A4%E3%83%B3%E3%83%9D%E3%83%BC%E3%83%88%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB.xlsx';
        break;
      default :
        return;
    }
    this.$api.fileDownload(url);
  }
}
